import { reactive, readonly } from 'vue'

const state = reactive({
  user:  JSON.parse(localStorage.getItem('todo_user')  || 'null'),
  token: localStorage.getItem('todo_token') || null,
})

export function useAuth() {
  function setSession(token, user) {
    state.token = token
    state.user  = user
    localStorage.setItem('todo_token', token)
    localStorage.setItem('todo_user', JSON.stringify(user))
  }

  function clearSession() {
    state.token = null
    state.user  = null
    localStorage.removeItem('todo_token')
    localStorage.removeItem('todo_user')
  }

  const isLoggedIn      = () => !!state.token
  const isManager       = () => state.user?.role === 'manager'
  const isExternalClient = () => state.user?.user_type === 'external'
  const currentUser     = () => state.user

  return { state: readonly(state), setSession, clearSession, isLoggedIn, isManager, isExternalClient, currentUser }
}
